import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { CtaButton } from '@tkww/orion-web-ds-action';
import React, { type FC } from 'react';
import { connect } from 'react-redux';
import AnalyticsConstants from '../../../../../../../constants/analytics';
import VendorAnalytics from '../../../../../../decorators/vendorAnalytics';
import Styles from './SeeAllPhotosCTA.scss';
import { PhotosIcon } from './ components/PhotosIcon';

export interface SeeAllPhotosCTAProps {
	count: number;
	vendor: Vendor.Decorated;
	onClick?: () => void;
}

/** @internal */
export const SeeAllPhotosCTA: FC<SeeAllPhotosCTAProps> = (props) => {
	const { count, vendor, onClick } = props;
	const { track } = useAnalyticsContext();

	const trackClick = () => {
		const vendorAnalytics = new VendorAnalytics(vendor);
		const sourcePage =
			vendor.purchaseStatus === 'PAID'
				? AnalyticsConstants.PAID_STOREFRONT
				: AnalyticsConstants.UNPAID_STOREFRONT;
		track({
			event: AnalyticsConstants.VENDOR_PORTFOLIO_INTERACTION,
			properties: {
				action: AnalyticsConstants.SEE_ALL_IMAGES,
				sourcePage,
				sourceContent: AnalyticsConstants.MOSAIC,
				...vendorAnalytics.baseEventProps(),
			},
		});
	};

	const seeAll = () => {
		if (onClick) {
			onClick();
			trackClick();
		} else {
			trackClick();
		}
	};

	return (
		<CtaButton
			className={Styles.galleryCtas}
			styleType="secondary"
			onClick={seeAll}
			aria-label="see-all-photos"
			size="md"
		>
			<PhotosIcon />
			<span className={Styles.galleryCtasText}>{`See all (${count})`}</span>
		</CtaButton>
	);
};

const mapStateToProps = (state: Redux.State) => ({
	vendor: state.vendor.vendor,
});

export default connect(mapStateToProps)(SeeAllPhotosCTA);
